/**
 * created by lei lei
 * 页面外部整体滚动条
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";

export default class PageScrollBars extends Component {
    static defaultProps = {};
    static propTypes = {
        content:PropTypes.element.isRequired,//传入dom 结构
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let height = window.innerHeight - 70;
        return (
            <div className={'PageScrollBars'} style={{position: 'relative', height: height}}>
                <Scrollbars>
                    <div style={{position: 'relative', padding: 15}}>
                        <div style={{maxHeight: height - 20, background: 'white',overflow:'hidden', borderRadius: "5px"}}>
                            {this.props.content}
                        </div>
                    </div>
                </Scrollbars>
            </div>
        )
    }

}